<template>
  <DragDialog
    class="inner-pop-primary"
    title="场景信息"
    :width="320"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
  >
    <div class="scene-info-box">
      <div class="item-box">
        <div class="label dialog-label">场景名称：</div>
        <div class="content dialog-label">
          {{ sceneInfo.sceneName }}
        </div>
      </div>
      <div class="item-box">
        <div class="label dialog-label">显示方式：</div>
        <div class="content display-mode-box dialog-label">
          {{ sceneInfo.displayMode === "Sphere" ? "三维球体" : "平面" }}
        </div>
      </div>
      <div class="item-box">
        <div class="label dialog-label">元素个数：</div>
        <div class="content dialog-label">{{ sceneInfo.countDataSets }}</div>
      </div>
      <div class="item-box">
        <div class="label dialog-label">构件总数：</div>
        <div class="content dialog-label">{{ sceneInfo.countElement }}</div>
      </div>
      <div class="item-box">
        <div class="label dialog-label">三角面数：</div>
        <div class="content dialog-label">
          {{ sceneInfo.countFace !== -1 ? sceneInfo.countFace : "--" }}
        </div>
      </div>
      <div class="item-box">
        <div class="label dialog-label">坐标系：</div>
        <div
          v-if="sceneInfo.coordinatesType === 'None'"
          class="content dialog-label"
        >
          无
        </div>
        <div class="content dialog-label moreInfo" v-else>
          {{ sceneInfo.coordinates }}
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

import { getSceneSummaryService } from "@/service/interface";

export default {
  data() {
    return {
      sceneInfo: {},
    };
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: { DragDialog },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initSceneInfo();
      }
    },
  },
  methods: {
    initSceneInfo() {
      let sceneId = this.$route.query.sceneId;
      getSceneSummaryService(sceneId).then((response) => {
        if (response.isSuccess) {
          let data = response.data;
          let sceneInfo = data;
          this.sceneInfo = sceneInfo;
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
/deep/ .dialog-box {
  .dialog-content {
    padding: 16px;
    padding-bottom: 32px;
  }
}

.scene-info-box {
  .item-box {
    display: flex;
    align-items: center;
    font-size: 14px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    .label {
      flex-shrink: 0;
      width: 72px;
      text-align: right;
    }

    .moreInfo {
      word-break: break-all;
      border: 1px solid var(--scene-edit-info-border-color);
      border-radius: 8px;
      background: var(--base-bg-dark-color33);
      padding: 8px;
    }

    .content {
      flex-grow: 1;
      padding: 4px 10px;
      border-radius: 4px;
      max-height: 100px;
      overflow: auto;
    }
  }
}
</style>